// extracted by mini-css-extract-plugin
export default {"spin":"Spinner2_spin__pSrke"};